export const GET_LINKS = 'GET_LINKS';
export const GET_URL_FOR_ASSOCIATED_LINK = "GET_URL_FOR_ASSOCIATED_LINK";



// WEBPACK FOOTER //
// ./src/actions/links/types.js